import type { OrgBillingLockReason } from '@mfw/common';
import type { MessageDescriptor } from 'react-intl';

import messages from './messages';

/**
 * THE title/body pair for a locked organization, chosen by the lock REASON.
 *
 * One function because more than one screen explains the same lock — the org
 * section's `OrgBillingLockedScreen` and the public organization profile — and
 * they must never answer differently. The profile is the one that matters most:
 * it is reached from the public directory, featured authors and organizations,
 * and the module and episode viewers, and it rendered the harshest sentence in
 * the app ("suspended due to an unpaid balance… as soon as the debt is
 * settled") off the lock BOOLEAN alone, for an organization that had simply
 * cancelled and owed nothing.
 *
 * `'unpaid'` keeps today's copy. Anything else that is not the ended reason
 * keeps it too — the backend derives the boolean FROM the reason at one
 * chokepoint (`locked = reason !== null`), so a locked row without a reason is
 * not reachable from the wire.
 */
export function orgLockCopy(reason: OrgBillingLockReason | null | undefined): {
  hasEnded: boolean;
  title: MessageDescriptor;
  body: MessageDescriptor;
} {
  const hasEnded = reason === 'subscription_ended';
  return {
    hasEnded,
    title: hasEnded ? messages.orgEndedTitle : messages.orgLockedTitle,
    body: hasEnded ? messages.orgEndedBody : messages.orgLockedBody,
  };
}
